import Link from 'Component/Link';
import {
    MenuItemComponent as SourceMenuItemComponent,
} from 'SourceComponent/MenuItem/MenuItem.component';
import {ReactElement} from 'Type/Common.type';

/** @namespace Steinkrueger/Component/MenuItem/Component */
export class MenuItemComponent extends SourceMenuItemComponent {
    renderItemLinkContent(): ReactElement {
        const {
            activeMenuItemsStack,
            item,
            itemMods,
            handleCategoryHover,
            handleLinkLeave,
            onItemClick,
        } = this.props;

        const {
            url,
            item_id,
            children,
        } = item;

        const isParent = !!Object.keys(children).length;

        const isHovered = activeMenuItemsStack.includes(item_id);

        return (
            <Link
              to={ url }
              block="Menu"
              elem="Link"
              id={ item_id }
              onMouseEnter={ handleCategoryHover }
              onMouseLeave={ handleLinkLeave }
              mods={ { isHovered, isParent } }
              onClick={ onItemClick }
            >
                { this.renderItemContent(item, itemMods) }
            </Link>
        );
    }
}

export default MenuItemComponent;
